import { render, staticRenderFns } from "./GroupClientList.vue?vue&type=template&id=97b9967e"
import script from "./GroupClientList.vue?vue&type=script&lang=js"
export * from "./GroupClientList.vue?vue&type=script&lang=js"
import style0 from "./GroupClientList.vue?vue&type=style&index=0&id=97b9967e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports